export default __webpack_public_path__ + "static/media/Sam-Trickett.ae1aaeab.png";